export default __webpack_public_path__ + "static/3p9-panels-c3aa167235aa5ab578d853b21d61c7f7.png";